<div *ngFor="let entry of entries$ | async">
	<h3>{{ entry.header }}</h3>
	<div class="timestamp">{{ entry.timestamp }}</div>
	<div class="field" *ngFor="let field of entry.fields">
		<span>{{ field.label | translate }}</span>
		<ng-template #withoutLink>
			<span>{{ field.value }}</span>
		</ng-template>
		<button *ngIf="field.clickHandler; else: withoutLink" class="clickable" (click)="field.clickHandler()">{{ field.value }}</button>
	</div>
</div>